import { Component, OnInit, ViewChild } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ControlPermission } from '@pages/modules-permission/interfaces/controlPermission';
import { ControlFormComponent } from './control-form/control-form.component';
import { SwalService } from '@shared/utils/swal.service';
import { ControlesService } from '@pages/modules-permission/services/controles.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';

@Component({
  selector: 'app-control-permission',
  templateUrl: './control-permission.component.html',
  styleUrls: ['./control-permission.component.css'],
})
export class ControlPermissionComponent implements OnInit {
  private readonly _width: string = '1000px';
  public allData: number = 0;
  public loading: boolean = true;
  id: number = 0;
  displayedColumns: string[] = [
    'actions',
    'permissionControlId',
    'controlName',
    'description',
    'formName',
    'enable',
    'userCreator',
    'visible',
  ];
  dataSource = new MatTableDataSource();
  constructor(
    public _dialog: MatDialog,
    private _swalService: SwalService,
    private _controlService: ControlesService,
    private route: ActivatedRoute,
  ) {}
  @ViewChild(MatPaginator) paginator: MatPaginator;
  

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.id = +this.route.snapshot.paramMap.get('id');
    this.read();
    this.loadControls();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read() {
    this._controlService.read(this.id).subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

loadControls(){
  this._controlService.readControls(this.id).subscribe((res) => {
    sessionStorage.setItem('Forms', JSON.stringify(res["data"]));    
  });
}

  openCreate() {
    const dialogRef = this._dialog.open(ControlFormComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openUpdate(model: ControlPermission) {
    const dialogRef = this._dialog.open(ControlFormComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }
  
  delete(model: ControlPermission) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._controlService.delete(model).subscribe((res) => {
          if (res.exito === 1) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.read();
        });
      }
    });
  }

}
